import bannerImg from './banners/woman-helping-man-gym.jpg';

export default {
    id: 'lead-nutricao-online',
    title: 'Captação de leads — Nutrição online',
    description: 'Capture leads interessados na sua consultoria de nutrição online com perguntas objetivas e de fácil preenchimento.',
    indicatedFor: 'Nutricionistas',
    stepsCount: 1,
    questionsSummary: ['Nome e contato', 'Objetivo alimentar', 'Histórico de dietas', 'Disponibilidade'],
    banner: `url(${bannerImg}) center / cover no-repeat`,
    formData: {
        title: 'Quero melhorar minha alimentação',
        active: false,
        allow_multiple_answers: false,
        theme: 'light',
        steps: [
            {
                order: 1,
                title: 'Fale um pouco sobre você',
                description: null,
                header: null,
                submitAction: 'next_step',
                submitButtonText: 'Enviar',
                allowReturn: false,
                submitLink: null,
                questions: [
                    {
                        order: 1,
                        type: 'full_name',
                        label: 'Seu nome',
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 2,
                        type: 'email',
                        label: 'Seu e-mail',
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 3,
                        type: 'phone',
                        label: 'WhatsApp',
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 4,
                        type: 'choices',
                        label: 'Qual é o seu principal objetivo nutricional?',
                        description: null,
                        required: true,
                        settings: {
                            options: [
                                { id: 'opt-1', label: 'Emagrecer' },
                                { id: 'opt-2', label: 'Ganhar massa muscular' },
                                { id: 'opt-3', label: 'Tratar uma condição de saúde' },
                                { id: 'opt-4', label: 'Melhorar a energia e disposição' },
                                { id: 'opt-5', label: 'Reeducação alimentar' },
                            ],
                        },
                    },
                    {
                        order: 5,
                        type: 'yes_no_maybe',
                        label: 'Você já fez acompanhamento com nutricionista antes?',
                        description: null,
                        required: false,
                        settings: null,
                    },
                ],
            },
        ],
        actions: [],
    },
};
